import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { cn, Typography } from '@kiiwi/ui';
import { useTranslation } from '@/src/i18n';

type ProCardFirstAvailabilityProps = {
  date?: Dayjs;
  className?: string;
  onClick: (event: React.MouseEvent) => void;
};

const ProCardFirstAvailability = ({
  date,
  className,
  onClick,
}: ProCardFirstAvailabilityProps) => {
  const { t } = useTranslation();

  const formattedDate = React.useMemo(() => {
    if (!date) return;
    if (date.isToday()) return t('today');
    if (date.isTomorrow()) return t('tomorrow');
    if (date.isSame(new Date(), 'year'))
      return dayjs(date).format('dddd D MMMM');
    return dayjs(date).format('dddd D MMMM YYYY');
  }, [date]);

  if (!date) return null;
  return (
    <div
      className={cn(
        'flex w-max flex-col items-center justify-center rounded-lg border border-neutral bg-surface-white px-4 py-2',
        className,
      )}
      onClick={onClick}
    >
      <Typography variant="body-2">
        {t('pro_card_next_available_on')}
      </Typography>
      <Typography className="font-semibold">{formattedDate}</Typography>
    </div>
  );
};

export default ProCardFirstAvailability;
